import React from 'react';
import { Typography, Grid } from '@mui/material';

import TopThreats from './TopThreats';

const ThreatMetrics = () => (
  <>
    <Typography component="h2" sx={{ color: '#1A2E42', fontSize: 34, lineHeight: '42px' }}>
      Top Threat Metrics
    </Typography>
    <Grid container spacing={3} mt={1}>
      <Grid item xs={12} md={6} data-testid="threat-top-details">
        <TopThreats logAttr="Details" attributes="details" label="5 Threats" />
      </Grid>
      <Grid item xs={12} md={6} data-testid="threat-top-destination">
        <TopThreats logAttr="Destination" attributes="destination_fqdn" label="5 Targets" />
      </Grid>
      <Grid item xs={12} md={6} data-testid="threat-top-user">
        <TopThreats logAttr="User" attributes="user" label="5 User Threats" />
      </Grid>
      <Grid item xs={12} md={6} data-testid="threat-top-source">
        <TopThreats logAttr="Source" attributes="source_fqdn" label="5 Attacks" />
      </Grid>
    </Grid>
  </>
);

export default ThreatMetrics;
